<!-- <section class="conversation-history" aria-label="Conversation history">
  <h2 class="conversation-history__title">Conversation History</h2>
</section> -->

<talk-to-your-data-collapsible-section
  class="collapsible-section--fill"
  title="Conversation History"
  [count]="(history || []).length"
  icon="chat-filled"
>
  <ng-container *ngIf="(history || []).length > 0; else emptyState">
    <ul class="conversation-history__items">
      <li
        class="conversation-history__item"
        *ngFor="let item of history || []; let index = index; trackBy: trackByConversationId"
      >
        <talk-to-your-data-conversation-list-item
          [item]="item"
          [conversationId]="item.conversationId || item.id || ''"
          [testId]="'conversation-history-item-' + index"
          [selected]="(item.conversationId || item.id) === selectedConversationId"
          (conversationSelected)="onConversationSelected($event)"
          (actionSelected)="onMenuAction($event)"
        ></talk-to-your-data-conversation-list-item>
      </li>
    </ul>
  </ng-container>

  <ng-template #emptyState>
    <div class="empty-history-state">
      <p class="empty-history-state__subtitle">No conversations open yet</p>
    </div>
  </ng-template>
</talk-to-your-data-collapsible-section>
